import React from "react";
import CustomModal from "../../Modal/CustomModal";
import '.././popup.common.css'
import BorderedButton from "../../Buttons/BorderedButton";
import PrimaryButton from "../../Buttons/PrimaryButton";
import styles from "./Style.module.css";

const ConfirmedAgainPopup = ({ onClose, onConfirm }) => {
	return (	
	<CustomModal  
		show={true} 
		onHide={onClose}
	>
		<div className={`popup ${styles.confirmedAgainPopup}`}>	
            <div className="header">
                <h2>Switching Status</h2>
				<p>Switching from 'Checked-in' to 'Confirmed' status will retain all check-in data. If you need to submit new check-in records, please delete them under reports {'>'} Check-in.</p>
            </div>

            <div className="body">
                
            </div>

            <div className="footer">
                <BorderedButton 
					text="Cancel" 
					onClick={onClose} 
				/>
                <PrimaryButton
					text="Switch to ‘Confirmed’"
					onClick={onConfirm}
				/>
            </div>
        </div>
	</CustomModal>
	);
};

export default ConfirmedAgainPopup;
